import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrManager } from "ng6-toastr-notifications";
import { NgxSpinnerService } from "ngx-spinner";
import { DataService } from "../data.service";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"]
})
export class ProfileComponent implements OnInit {
  public username;
  public attributes;
  public sub;
  public email_verified: string="";
  public phone_number_verified: string;
  public phone_number;
  public email;
  public picture;

  constructor(
    private route: ActivatedRoute,
    private toastr: ToastrManager,
    private spinner: NgxSpinnerService,
    private dataService: DataService,
    private router: Router
  ) {}

  ngOnInit() {
    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 2 seconds */
      this.spinner.hide();
    }, 4000);

    this.route.params.subscribe(params => {
      this.username = params.userName;
      this.dataService.getUsersList().subscribe((res: any) => {
        if (typeof res == "string") {
          res = JSON.parse(res);
        }
        console.log(res);
        for (var i = 0; i < res.Data.Users.length; i++) {
          if (this.username == res.Data.Users[i].Username) {
            this.attributes = res.Data.Users[i].Attributes;
            // console.log(this.attributes)
            this.attributes.forEach(attr => {
              console.log(attr);
              switch (attr.Name) {
                case "sub":
                  this.sub = attr.Value;
                  break;
                case "email_verified":
                console.log(typeof attr.Value)
                  attr.Value == 'false'
                    ? (this.email_verified = "Email Not Verified")
                    : (this.email_verified = "Email Verified");
                  break;
                case "phone_number_verified":
                  attr.Value == "false"
                    ? (this.phone_number_verified = "Phone Number Not Verified")
                    : (this.phone_number_verified = "Phone Number Verified");
                  break;
                case "phone_number":
                  this.phone_number = attr.Value;
                  break;
                case "email":
                  this.email = attr.Value;
                  break;
                case "picture":
                  this.picture = attr.Value;
                  break;
                default:
                  break;
              }
            });
          }
        }
        console.log(this.phone_number_verified);
      });
    });
  }

  getprofileImage(){
    if(this.picture != null){
      return this.picture;
    }else {
      return "https://s3.amazonaws.com/admin-panel-aws/dummy.jpeg";
    }
  }
  editUser(){
    this.router.navigate(["/update-user", { userName: this.username }]);
  }
}
